// extracted by mini-css-extract-plugin
export default {"commonBalanceInput":"commonBalanceProps_commonBalanceInput__4uEFe","placeHolderShimmer":"commonBalanceProps_placeHolderShimmer__uc3nC"};